import * as React from 'react';
import { useContext } from 'react';

import type { Role } from '@coursera/event-pulse-types';

export type EventingType = {
  role?: Role;
};

const EventingContext = React.createContext<EventingType>({});

export const useEventingData = () => {
  return useContext(EventingContext) ?? {};
};

export default EventingContext;
